import { gql } from '@apollo/client'

export const ADD_TO_PAYOUT_MUTATION = gql`
  mutation addToPayout($processingId: ID!) {
    addToPayout(processingId: $processingId) {
      id
    }
  }
`
